export let usuariosRedux=(valor)=>{ return {type:"USUARIOS",payload:valor} };
export let usuarioSelected=(valor)=>{ return {type:"USUARIO_SELECTED",payload:valor} };
export let estadoUsuario=(valor)=>{ return {type:"ESTADO_USUARIO",payload:valor} };
export let newUsuario=(valor)=>{ return {type:"NEW_USUARIO",payload:valor} };
export let userFilter=(valor)=>{ return {type:"USER_FILTER",payload:valor} };